export default {
  en: 'en',
  shortFr: 'fr',
  longFr: 'fr-CA',
  lcidEn: 1033,
  lcidFr: 1036,
  atsEn: 'EN_CA',
  atsFr: 'FR_CA',
};
